import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import FeatherIcon from 'feather-icons-react';
import { Modal, Row, Col, Table, message } from 'antd';
import { AutoComplete } from '../../../components/autoComplete/autoComplete';
import { CampaignUpdate } from '../../../Api/Services/CampaignApiServices';
import { Button } from '../../../components/buttons/buttons';


const Popup = ({ openUser, usersTableColumns, filterDatas, exportData, OpenUserTable,
    selectedRowKeys, setFilterDatas, displayData, getCampaignData }) => {
    const [searchText, setSearchText] = useState("");
    const [display, setDisplay] = useState(false)
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const [selectedRowKeysPopup, setSelectedRowKeysPopup] = useState([]);
    const onSelectChangePopup = (newSelectedRowKeys) => {
        setSelectedRowKeysPopup(newSelectedRowKeys);
    };
    const rowSelectionPopup = {
        selectedRowKeysPopup,
        onChange: onSelectChangePopup,
    };
    function updateCampaignIds(campaign, newIds, type) {
        const field = type === 'Lead' ? 'leads' : 'contacts';
        const existingIds = campaign[field]
            ? campaign[field].split(',').map(id => parseInt(id.trim())).filter(Boolean)
            : [];
        const updatedIds = Array.from(new Set([...existingIds, ...newIds]));
        const updatedString = updatedIds.join(',');

        return { [field]: updatedString };
    }

    const ConfirmUser = async () => {
        if (selectedRowKeysPopup.length) {
            if (loadingRef.current) return;
            loadingRef.current = true;
            setDelteClick(true)
            setDisplay(true)
            let hideMessage;
            const formData = updateCampaignIds(displayData, selectedRowKeysPopup, 'Contact')
            try {
                hideMessage = message.loading("Loading...", 0);
                const response = await CampaignUpdate(formData, displayData?.campaignId)
                if (response.status === 200) {
                    message.success(`Selected residents have been successfully added to the campaign`)
                    hideMessage();
                    setDisplay(false)
                    OpenUserTable()
                    getCampaignData()
                    loadingRef.current = false;
                    setDelteClick(false)
                }
            }
            catch (error) {
                loadingRef.current = false;
                setDelteClick(false)
                hideMessage();
                setDisplay(false)
                message.error(error)
            }
        }
        else {
            message.error("Please select atleast one resident")
        }
    }
    const handleSearch = (searchText) => {
        setSearchText(searchText);
    };

    const filterData = (data) => {
        let filteredData = [...data];
        if (searchText) {
            filteredData = filteredData.filter(item => {
                const searchableFields = [
                    item.first_name,
                    item.last_name,
                    item.email,
                    item.designation,
                ];
                return searchableFields.some(field =>
                    field && field.toString().toUpperCase().includes(searchText.toUpperCase())
                );
            });
        }
        return filteredData;
    };
    const applyFilters = () => {
        const filteredData = filterData(exportData);
        setFilterDatas(filteredData);
    };
    useEffect(() => {
        applyFilters();
    }, [searchText]);
    const usersTableDataPopup = [];
    if (filterDatas !== undefined) {
        filterDatas.map((user) => {
            return usersTableDataPopup.push({
                key: user.contacts_id,
                name: (<div className="user-info_image table_list_clicks">
                    {user.contacts_id && (user.contact_profile !== null && user.contact_profile
                        !== undefined && user.contact_profile !== "" ?
                        <figure>
                            <img style={{ width: "30px", height: "30px" }} src={user.contact_profile} alt="" />
                        </figure>
                        :
                        <span className='list_span_Tag LeadIcon'>
                            {user.first_name && user.first_name.slice(0, 1).toUpperCase()}
                        </span>
                    )}
                    {user.contacts_id &&
                        <figcaption>
                            <div>
                                {`${user.first_name} ${user.last_name}`}
                            </div>
                            <div className='entityemail'>
                                {user.email}
                            </div>
                        </figcaption>
                    }
                </div>),
                accountname: (<div className='table_list_clicks'>{user.account_name}</div>),
                designation: (<div className='table_list_clicks'>{user.designation}</div>),
            });
        });
    }
    return (
        <Modal
            title={
                <Row>
                    <Col xxl={4} lg={4} xs={24}>
                        <div style={{ margin: "7px 0px" }}>
                            Select Residents
                        </div>
                    </Col>
                    <Col xxl={12} lg={12} xs={24}>
                        <AutoComplete
                            onSearch={handleSearch}
                            dataSource={usersTableDataPopup.filter(item => !selectedRowKeys.includes(item.key))}
                            placeholder="Search by Name"
                            width="100%"
                            patterns />
                    </Col>
                </Row>
            }
            open={openUser}
            onCancel={OpenUserTable}
            maskClosable={false}
            footer={[
                <div>
                    <Button htmlType="submit" className="button_colors" onClick={ConfirmUser} disabled={display || deleteClick} loading={deleteClick}>
                        {!deleteClick && <FeatherIcon icon="plus" />}Add
                    </Button>
                </div>
            ]}
            width={1000}
        >
            <div className="table-bordered leaderboard-table table-responsive CampaignTable-pagination">
                <Table
                    showSorterTooltip={false}
                    rowSelection={rowSelectionPopup}
                    dataSource={usersTableDataPopup.filter(item => !selectedRowKeys.includes(item.key))}
                    columns={usersTableColumns}
                    pagination={{
                        total: usersTableDataPopup.filter(item => !selectedRowKeys.includes(item.key)).length,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                    }}
                />
            </div>
        </Modal >
    );
};

Popup.propTypes = {
    openUser: PropTypes.bool.isRequired,
    selectedRowKeys: PropTypes.array.isRequired,
    usersTableColumns: PropTypes.array.isRequired,
    filterDatas: PropTypes.array.isRequired,
    setFilterDatas: PropTypes.func.isRequired,
    exportData: PropTypes.array.isRequired,
    OpenUserTable: PropTypes.func.isRequired,
    displayData: PropTypes.object.isRequired,
    getCampaignData: PropTypes.func.isRequired,
};

export default Popup;